import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import history from "./helpers/history";
// import { renderRoutes } from 'react-router-config';
import "./App.scss";
import FullLoader from "./components/FullLoader";
import ProtectedRoute from "./routes/ProtectedRoute";

const loading = () => <FullLoader />;

// Layout
const Layout = React.lazy(() => import("./layouts"));

// Pages
const Logout = React.lazy(() => import("./pages/Logout"));
const LoginUser = React.lazy(() => import("./pages/Login"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
const ResetPasswordRequest = React.lazy(() =>
  import("./pages/ResetPassword/ResetPasswordRequest")
);
const Page404 = React.lazy(() => import("./pages/404"));
const Onboarding = React.lazy(() => import("./pages/Onboarding"));
const Migration = React.lazy(() => import("./pages/Migration"));
const OTP = React.lazy(() => import("./pages/OTP"));
const ChangePassword = React.lazy(() => import("./pages/ChangePassword"));

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              exact
              path="/logout"
              name="Logout Page"
              render={(props) => <Logout {...props} />}
            />
            <Route
              exact
              path="/login"
              name="Login Page"
              render={(props) => <LoginUser {...props} />}
            />
            <Route
              exact
              path="/otp"
              name="One Time Password Page"
              render={(props) => <OTP {...props} />}
            />
            <Route
              exact
              path="/reset-password-request/:app_secret"
              name="Reset Password Request Page"
              render={(props) => <ResetPasswordRequest {...props} />}
            />
            <Route
              exact
              path="/change-password"
              name="Change Password"
              render={(props) => <ChangePassword {...props} />}
            />
            <Route
              exact
              path="/reset-password"
              name="Reset Password Page"
              render={(props) => <ResetPassword {...props} />}
            />
            <Route
              exact
              path="/migration"
              name="Migration Page"
              render={(props) => <Migration {...props} />}
            />
            <Route
              exact
              path="/404"
              name="404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              path="/create-account/:token"
              render={(props) => <Onboarding {...props} />}
            />
            <ProtectedRoute
              path="/"
              component={(props) => <Layout {...props} />}
            />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
